import { TXLogger } from "@tx/framework";
import dayjs from "dayjs";
import dayjs_timezone from "dayjs/plugin/timezone";
import dayjs_utc from "dayjs/plugin/utc";
import opening_hours from "opening_hours";

import { CountriesEnum, nominatim_objects, timezones } from ".";

dayjs.extend(dayjs_utc);
dayjs.extend(dayjs_timezone);

export function IsStoreOpen(
	country_code: CountriesEnum,
	open_hours_string = "",
	showLogs = false
) {
	const _showLogs = showLogs || process.env.DEBUG_STORE_OPEN;

	const timezone = timezones[country_code];

	const currentDate = dayjs();
	const offset_currentMachine = currentDate.utcOffset();

	const offset_storeCountry = currentDate.tz(timezone).utcOffset();

	/** substract current machine timezone difference + adds store timezone difference */
	const normalizedDate = currentDate
		.add(-offset_currentMachine + offset_storeCountry, "minutes")
		.toDate();

	// open_hours_string = "11:00-11:30";

	const isStoreOpen = getOpenHours(country_code, open_hours_string).getState(
		normalizedDate
	);

	if (_showLogs) {
		TXLogger.trace("IsStoreOpen", "IS OPEN", {
			extra: {
				offsets: {
					currentDate: currentDate.toDate().getTimezoneOffset(),
					offset_currentMachine,
					offset_storeCountry,
				},
				normalized: {
					open: isStoreOpen,
					toDate: normalizedDate.toTimeString(),
					toUtcString: normalizedDate.toUTCString(),
				},
				currentDate: {
					open: getOpenHours(country_code, open_hours_string).getState(
						currentDate.toDate()
					),
					toDate: currentDate.toDate().toTimeString(),
					toUtcString: currentDate.toDate().toUTCString(),
				},
			},
		});
	}

	return isStoreOpen;
}

function getOpenHours(country_code: CountriesEnum, open_hours_string = "") {
	if (country_code == CountriesEnum.IL) {
		open_hours_string = open_hours_string
			// .replaceAll("PH,", "")
			.replace("PH", "");
	}

	const open_hours = new opening_hours(
		open_hours_string
		// nominatim_objects[country_code].nominatim_object
	);

	return open_hours;
}
